"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPropertiesContainerProperty = exports.propertiesContainerPropertyDefinition = void 0;
exports.propertiesContainerPropertyDefinition = {
    view: {
        label: 'Properties',
        style: '',
    },
    constraints: [
        {
            name: 'properties',
            argument: ['property'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'properties-container',
};
const isPropertiesContainerProperty = (prop) => {
    return prop.name === exports.propertiesContainerPropertyDefinition.name;
};
exports.isPropertiesContainerProperty = isPropertiesContainerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvcGVydGllcy1jb250YWluZXIucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9wcm9wZXJ0aWVzLWNvbnRhaW5lci5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHFDQUFxQyxHQUFHO0lBQ25ELElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxZQUFZO1FBQ25CLEtBQUssRUFBRSxFQUFFO0tBQ1Y7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxZQUFZO1lBQ2xCLFFBQVEsRUFBRSxDQUFDLFVBQVUsQ0FBQztTQUN2QjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsc0JBQXNCO0NBQ0csQ0FBQTtBQUkxQixNQUFNLDZCQUE2QixHQUFHLENBQUMsSUFBa0IsRUFBdUMsRUFBRTtJQUN2RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssNkNBQXFDLENBQUMsSUFBSSxDQUFBO0FBQ2pFLENBQUMsQ0FBQTtBQUZZLFFBQUEsNkJBQTZCLGlDQUV6QyJ9